import { render, staticRenderFns } from "./CashAdvances.vue?vue&type=template&id=2abb2069&scoped=true"
import script from "./CashAdvances.vue?vue&type=script&lang=js"
export * from "./CashAdvances.vue?vue&type=script&lang=js"
import style0 from "./CashAdvances.vue?vue&type=style&index=0&id=2abb2069&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abb2069",
  null
  
)

export default component.exports